import { gql } from "apollo-boost";

export const GET_QUESTIONS = gql`
  query questions($sectionId: ID!) {
    questions(sectionId: $sectionId) {
      id
      text
      questionType
      answerOptions {
        id
        text
      }
    }
  }
`;
export const GET_NEXT_SECTIONS = gql`
  {
    nextSections {
      id
      name
      courseName
      previewUrl
      courseId
      readableDuration
      numberOfSectionsInCourse
      order
    }
  }
`;

export const GET_NEXT_SECTION = gql`
  {
    nextSection {
      id
      name
      courseName
      previewUrl
      courseId
      readableDuration
      numberOfSectionsInCourse
      order
    }
  }
`;

export const GET_RECOMMENDED_SECTION = gql`
  query GetRecommendedSection {
    nextRecommendedSection {
      id
      name
      courseId
    }
  }
`;


export const GET_SURVEYS = gql`
  {
    questionnaires {
      id
      name
      active
      sequenceNumber
      tillDate
      credits
      questions {
        id
        questionType
        text
        sequenceNumber
        active
        required
        from
        till
        answerOptions {
          text
          id
          sequenceNumber
        }
      }
    }
  }
`;

export const GET_STATISTICS_QUERY = gql`
  {
    statistics {
      achievedPoints
      availablePoints
      spentPoints
      finishedCourses
      finishedSections
      finishedMinutes
      courseStatistics {
        courseName
        courseNameShort
        progress
        credits
        courseId
        color
      }
      certificates {
        id
        name
        url
      }
    }
  }
`;

export const GET_USER_POINTS_QUERY = gql`
  {
    statistics {
      availablePoints
    }
  }
`;

export const GET_USER_CERTIFICATES_QUERY = gql`
  {
      certificates {
        id
        name
        url
      }
  }
`;

export const GET_PHARMACY_QUERY = gql`
  query pharmacy($registrationCode: String!) {
    pharmacy(registrationCode: $registrationCode) {
      id
      name
    }
  }
`;

export const GET_COURSE_QUERY = gql`
  query course($id: ID!) {
    course(id: $id) {
      id
      name
      nameShort
      brand
      readableDuration
      previewUrl
      detailPreviewUrl
      credits
      legalText
      description
      sections {
        id
        name
        description
        previewUrl
        iconUrl
        disabledIconUrl
        credits
        videoUrl
        videoPreviewUrl
        pdfUrl
        popupIframeUrl
        audioUrl
        finished
        content
        startDate
        startDateDistance
        started
        locked
        readableDuration
        sectionType
        iframeUrl
      }
    }
  }
`;

export const GET_LECTION_QUERY = gql`
  query section($id: ID!) {
    currentUser {
      firstName
      lastName
      email
      pharmacy {
        oneKeyId
      }
      avatarUrl
      pharmacy {
        id
        oneKeyId
        name
        address
        zipcode
        city
      }
    }
    section(id: $id) {
      id
      name
      description
      legalText
      previewUrl
      credits
      videoUrl
      videoPreviewUrl
      pdfUrl
      popupIframeUrl
      finished
      content
      startDate
      started
      locked
      readableDuration
      courseId
      sectionType
      iframeUrl
      order
      isQuiz
      course {
        id
        legalText
      }
    }
  }
`;

export const COURSES_QUERY = gql`
  {
    allCourses {
      id
      name
      brand
      description
      previewUrl
      readableDuration
      locked
      startDate
      sections {
        id
        name
        description
        previewUrl
        credits
        videoUrl
        videoPreviewUrl
        pdfUrl
        popupIframeUrl
        finished
        sectionType
        iframeUrl
      }
    }
  }
`;

export const UNLOCKED_COURSES_QUERY = gql`
  {
    allUnlockedCourses {
      id
      name
      brand
      description
      previewUrl
      readableDuration
      locked
      startDate
      sections {
        id
        name
        description
        previewUrl
        credits
        videoUrl
        videoPreviewUrl
        pdfUrl
        popupIframeUrl
        finished
        sectionType
        iframeUrl
      }
    }
  }
`;

export const LATEST_COURSES_QUERY = gql`
  {
    latestCourses {
      id
      name
      nameShort
      brand
      description
      previewUrl
      readableDuration
      locked
      startDate
      sections {
        id
        name
        description
        previewUrl
        credits
        videoUrl
        videoPreviewUrl
        pdfUrl
        popupIframeUrl
        finished
        sectionType
        iframeUrl
      }
    }
  }
`;

export const CATEGORIES_WITH_PREVIEW_QUERY = gql`
   query CategoriesWithCourses {
     categoriesWithCourses {
       id
       name
       previewCourses {
         id
         nameShort
         previewUrl
       }
     }
   }
 `;
 
 export const CATEGORY_WITH_COURSES_QUERY = gql`
   query CategoryWithCourses($categoryId: ID){
     categoryWithCourses(categoryId: $categoryId) {
       id
       name
       description
       imageUrl
       courses {
         id
         nameShort
         previewUrl
       }
     }
   }
 `;
 

export const CURRENT_TRAINER_QUERY = gql`
  {
    currentTrainers {
      trainer {
          id
          gender
          firstName
          lastName
          teamName
          email
          phone
          numberOfFollowers
          numberOfTrainings
          numberOfPharmacies
          avatarUrl
      }
      region {
          id 
          name
          team
      }
  }
  }
`;

export const CURRENT_TRAINER_WITH_REGION_QUERY = gql`
  {
    currentTrainersWithRegion {
      trainer {
          id
          gender
          firstName
          lastName
          teamName
          email
          phone
          avatarUrl
      }
      region {
          id 
          name
          team
      }
    }
  }
`;

export const CURRENT_USER_QUERY = gql`
  {
    currentUser {
      id
      firstName
      lastName
      email
      phone
      address
      zipcode
      city
      profession {
        name
      }
      avatarUrl
      pharmacy {
        id
        name
        address
        oneKeyId
        zipcode
        city
        kyteTecStatus
      }
    }
  }
`;

export const GET_ACCEPTED_GENERAL_TERMS_AND_PRIVACY = gql`
  {
    currentUser {
      id
      updateGeneralTerms
      updatePrivacy
      acceptedGeneralTerms
      acceptedPrivacy
    }
  }
`;

export const GET_PHARMACIES_QUERY = gql`
  {
    allPharmacies {
      name
    }
  }
`;

export const IS_LOGGED_IN = gql`
  query IsUserLoggedIn {
    isLoggedIn @client
  }
`;

export const GET_USER_AND_PROFESSIONS_QUERY = gql`
  {
    professions {
      id
      name
    }
    currentUser {
      id
      firstName
      lastName
      email
      phone
      address
      zipcode
      city
      openPharmacyChangeRequest
      profession {
        id
        name
      }
      avatarUrl
      pharmacy {
        id
        name
        address
        zipcode
        city
      }
    }
  }
`;

export const GET_PROFESSIONS_QUERY = gql`
  query Profession {
    professions {
      id
      name
    }
  }
`;

export const GET_CAMPAIGNS_QUERY = gql`
  query Campaigns {
    campaigns {
      id
      title
      supplier
      subtitle
      description
      points
      participantRules
      discount
      coverImageUrl
      expiresAt
      couponCodes {
        couponState
      }
    }
  }
`;

export const GET_CAMPAIGNS_WITH_EXISITING_CODES_QUERY = gql`
  query Campaigns {
    purchasableCampaigns {
		  couponType{
		      id
		      title
		      supplier
		      subtitle
		      description
		      points
		      coverImageUrl
		      expiresAt
          participantRules
		      campaignType
		      couponCodes {
		        couponState
		      }
	    }
	     instantType{
		      id
		      title
		      supplier
		      subtitle
		      description
		      points
		      coverImageUrl
          participantRules
		      expiresAt
		      campaignType
		      couponCodes {
		        couponState
		      }
	    }

    }
  }
`;

export const GET_CAMPAIGN_QUERY = gql`
  query Campaign($id: ID!, $isMyCouponCampaign: Boolean) {
    campaign(id: $id, isMyCouponCampaign: $isMyCouponCampaign) {
      id
      title
      supplier
      subtitle
      discount
      description
      points
      campaignType
      participantRules
      expiresAt
      coverImageUrl
    }
  }
`;

export const GET_MY_CAMPAIGNS_QUERY = gql`
  query MyCampaigns {
    myCampaigns {
	    couponType{
		      id
		      title
		      supplier
		      subtitle
		      description
          participantRules
		      points
		      coverImageUrl
		      expiresAt
		      campaignType
		      couponCodes {
		        couponState
		      }
	    }
	     instantType{
		      id
		      title
		      supplier
		      subtitle
		      description
		      points
		      coverImageUrl
		      expiresAt
          participantRules
		      campaignType
		      couponCodes {
		        couponState
		      }
	    }

    }
  }
`;
export const GET_MY_COUPON = gql`
  query MyCoupon($campaignId: ID!) {
    myCoupons(campaignId: $campaignId) {
      id
      code
    }
  }
`;

export const GET_MY_COUPON_CODES = gql`
  query MyCouponCodes {
    myCouponCodes {
      id
      code
      campaign {
        id
        title
        supplier
        subtitle
        description
        points
        discount
        coverImageUrl
        expiresAt
      }
    }
  }
`;

export const GET_AVAILABLE_FEEDS = gql`
  query availableFeeds {
    availableFeeds {
      id
      name
      description
      sequenceNumber
      url
      logoUrl
    }
  }
`;

export const GET_LATEST_ENTRIES = gql`
  query getLatestEntries($feedId: Int!) {
    getLatestEntries(feedId: $feedId) {
      titel
      id
      articleId
      publishedAt
      excerpt
      url
      logoUrl
      liked
      renderMode
	    content
    }
  }
`;

export const GET_LIKED_ENTRIES = gql`
  query getLikedEntries {
    getLikedEntries {
      titel
      id
      articleId
      publishedAt
      excerpt
      url
      baseUrl
      logoUrl
      liked
      renderMode
	    content
    }
  }
`;

export const GET_FEED_BY_ID = gql`
  query getFeedById($id: Int!) {
    getFeedById(id: $id) {
      description
      url
      baseUrl
      logoUrl
    }
  }
`;

export const GET_HCP_PORTALS = gql`
  query GetHcpPortals {
    getHcpPortals {
      name
      description
      link
      imageUrl
    }
  }
`;

// export const GET_NEXT_APPOINTMENT = gql`
//   query {
//     nextAppointment {
//       id
//       date
//       trainer {
//         firstName
//         lastName
//         phone
//         teamName
//       }
//       orderItems{
//         id
//         amount
//         trainingName
//       }
//     }
//   }
// `;

// export const GET_ALL_APPOINTMENTS = gql`
//   query {
//     allAppointments {
//       id
//       date
//       trainer {
//         firstName
//         lastName
//         phone
//         teamName
//       }
//       orderItems{
//         id
//         amount
//         trainingName
//       }
//     }
//   }
// `;

export const GET_PHARMACY_PROJECTS = gql `
  query getPharmacyProjects{
    getPharmacyProjects{
      project{
        id
        name
      }
      requestSend
    }
  }
`

export const GET_NEXT_APPOINTMENT = gql `
  query getNextAppointment{
    getNextAppointment{
      id
      date
      trainer{
        firstName
        lastName
      }	
      orderItems{
        amount
        project {
          name
        }
		  }	
    }
  }
`

export const GET_ALL_APPOINTMENTS = gql `
  query getAllAppointments{
    getAllAppointments{
      id
      date
      trainer{
        firstName
        lastName
      }
    }
  }
`

export const GET_APPOINTMENT = gql `
  query getAppointment($appointmentId: ID!){
    getAppointment(appointmentId: $appointmentId){
      id
      date
      trainer{
        firstName
        lastName
        phone
        teamName			
      }
      orderItems{
        amount
        project {
          name
        }
      }		
    }
  }
`

export const GET_ADVERT = gql `
  query getAdvert{
    getAdvert {
			imageUrl
      link
      mandatoryText
      infoIconColor
    }
  }
`

export const GET_GENERAL_TERMS = gql `
  query GetGeneralTerms {
    getGeneralTerms {
     	id
      name
      content
    }
  }
`

export const GET_PRIVACY = gql `
  query GetPrivacy {
    getPrivacy {
     	id
      name
      content
    }
  }
`

export const GET_OPEN_GIVEAWAYS = gql `
  query GetOpenGiveaways {
    getOpenGiveaways{
      id
      imageUrl    
    }
  }
`

export const GET_GIVEAWAYS_BY_ID = gql `
  query GetGiveaway($id: ID!) {
    getGiveaway(id: $id){
      id
      name
      description
      giveawayType
      imageUrl    
      participantRules
      imageHeaders
      tillDate  
    }
  }
`

export const GET_GIVEAWAYS = gql `
  query GetGiveaways {
    getGiveaways{
      id
      name
      description
      imageUrl  
    }
  }
`